// extracted by mini-css-extract-plugin
module.exports = {"Impact":"Impact_Impact__3GmZp","nav":"Impact_nav__1mn10","left":"Impact_left__1dyYm","accordion":"Impact_accordion__PV1ha"};